import React, { Component } from "react";
import {
  travellerVerification,
  resendMail,
  resendMob,
} from "../../../../lib/travellerRegistration";

class Verification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: props.loading || false,
    };
  }
  componentWillUnmount() {
    this.props.setCommonError("");
  }
  getOtpValue = (className) => {
    const inputs = document.querySelectorAll(`.${className}`);
    return Array.from(inputs)
      .map((input) => input.value)
      .join("");
  };

  verification = (e) => {
    e.preventDefault();
    const {
      mobileOtp,
      emailOtp,
      site_id,
      user_id,
      onSuccess,
      setCommonError,
    } = this.props;

    this.setState({ loading: true });

    travellerVerification({
      mobile_otp: mobileOtp.join(""),
      email_otp: emailOtp.join(""),
      site_id,
      user_id,
    }).then((response) => {
      if (response.data?.email_verified) {
        this.setState({ loading: false });
        onSuccess();
      } else {
        console.log("res", response.error);
        this.setState({ loading: false });
        setCommonError("Invalid OTP.");
      }
    });
  };

  resendEmail = () => {
    const { clearOtpInputs, setCommonError, site_id, user_id, setEmailTime } =
      this.props;

    clearOtpInputs("emailOtp");
    setCommonError("");

    resendMail({
      site_id,
      user_id,
    }).then((response) => {
      if (response) {
        const expiryTime = Number(response?.data?.otp?.otp_expiry_time);
        // Convert seconds to milliseconds if needed
        const timeInMs = expiryTime < 10000 ? expiryTime * 1000 : expiryTime;
        setEmailTime(isNaN(expiryTime) ? 0 : timeInMs);
      }
    });
  };

  resendMobile = () => {
    const { clearOtpInputs, setCommonError, site_id, user_id, setMobileTime } =
      this.props;

    clearOtpInputs("mobileOtp");
    setCommonError("");

    resendMob({
      site_id,
      user_id,
    }).then((response) => {
      if (response.status) {
        const expiryTime = Number(response?.data?.otp?.otp_expiry_time);
        // Convert seconds to milliseconds if needed
        const timeInMs = expiryTime < 10000 ? expiryTime * 1000 : expiryTime;
        setMobileTime(isNaN(expiryTime) ? 0 : timeInMs);
      }
    });
  };

  renderOtpInputs = (className, otpValues, setOtp) => {
    return Array.from({ length: 6 }).map((_, idx) => (
      <input
        key={idx}
        type="text"
        className={className}
        value={otpValues[idx]}
        maxLength={1}
        onChange={(e) => {
          const val = e.target.value.replace(/\D/g, ""); // only digits
          if (val.length <= 1) {
            setOtp(idx, val);
          }

          // Move focus to next input automatically
          if (val && e.target.nextSibling) {
            e.target.nextSibling.focus();
          }
        }}
        onKeyDown={(e) => {
          if (
            e.key === "Backspace" &&
            !e.target.value &&
            e.target.previousSibling
          ) {
            e.target.previousSibling.focus();
            setOtp(idx - 1, "");
          }
        }}
        onPaste={(e) => {
          e.preventDefault();
          const pasted = e.clipboardData.getData("text").replace(/\D/g, "");
          if (!pasted) return;

          const newOtp = [...otpValues];
          for (let i = 0; i < 6; i++) {
            newOtp[i] = pasted[i] || "";
          }
          setOtp(null, newOtp);
        }}
      />
    ));
  };

  render() {
    const {
      styles = {},
      email = "",
      number = "",
      mobileOtp,
      emailOtp,
      emailTimeFormatted,
      mobileTimeFormatted,
      handleBack,
      emailOtpChange,
      mobileOtpChange,
      commonError,
      setCommonError,
    } = this.props;
    const { loading } = this.state;
    console.log('commonError', commonError);
    return (
      <div className={styles.verification_modal}>
        <div className={styles.verification_main_content}>
          <div className={styles.registration_form}>
            <div className={styles.form_container}>
              <div className={styles.form_header}>
                <h1 className={styles.registraion_title}>
                  Email Verification
                </h1>
                <img
                  src="/images/tb_arrow_left.svg"
                  alt="Back Arrow"
                  className={styles.back_arrow}
                  onClick={handleBack}
                />
              </div>

              <div className={styles.form_divider} />

              {/* Email Section */}
              <div className={styles.otp_section}>
                <p className={styles.verification_text}>
                  Please enter the OTP sent to your email{" "}
                  <strong>{email}</strong>
                </p>
                <p className={styles.otp_text}>Email OTP Code</p>
                <div className={styles.otp_input_group}>
                  {this.renderOtpInputs(
                    `${styles.email_otp_input}`,
                    emailOtp,
                    emailOtpChange
                  )}
                </div>
                <div>
                  <p className={styles.time_remaining}>
                    Time Remaining {emailTimeFormatted}
                  </p>
                  <p className={styles.resend_text}>
                    If you didn't receive a code{" "}
                    <a
                      onClick={
                        emailTimeFormatted === "00:00"
                          ?
                          this.resendEmail
                          : undefined
                      }
                      className={
                        emailTimeFormatted === "00:00"
                          ? styles.resend_link
                          : styles.resend_link_disabled
                      }
                    >
                      Resend OTP
                    </a>
                  </p>
                  {commonError && (
                    <div className={styles?.error_message}>{commonError}</div>
                  )}
                </div>
              </div>

              <div className={styles.verification_submit_container}>
                <button
                  disabled={emailOtp.join("").length < 6}
                  onClick={this.verification}
                  className={`${styles.register_btn} ${loading ? "loading" : ""
                    }`}
                >
                  <span>Verify</span>
                  <img src="images/button_arrow.svg" alt="Arrow Right" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Verification;
